import "core-js/modules/es.array.push.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "rewards-page page"
  }, [_c('m-head', {
    ref: "mHeadRef"
  }), _c('div', {
    staticClass: "rewards-main page-main"
  }, [_c('div', {
    staticClass: "rewards-body"
  }, [_c('div', {
    staticClass: "rewards-sign"
  }, [_c('div', {
    staticClass: "rewards-sign__title"
  }, [_vm._v("Sign in to get rewards")]), _c('div', {
    staticClass: "rewards-sign-list"
  }, _vm._l(_vm.dailyList, function (item, index) {
    return _c('div', {
      key: index,
      staticClass: "rewards-sign-item",
      class: item.completed && 'completed'
    }, [item.completed ? _c('div', {
      staticClass: "rewards-sign__status"
    }, [_c('svg-icon', {
      attrs: {
        "name": "icon-ok"
      }
    })], 1) : _c('div', {
      staticClass: "rewards-sign__icon"
    }, [_c('img', {
      attrs: {
        "src": require(`@images/${_vm.aiSkin}/icon-coin.png`),
        "alt": ""
      }
    })]), _c('div', {
      staticClass: "rewards-sign__num"
    }, [_vm._v("+" + _vm._s(_vm._f("fmt_pre")(item.coins)))]), _c('div', {
      staticClass: "rewards-sign__time"
    }, [_vm._v("Day " + _vm._s(index + 1))]), _vm.dailyList[index - 1] && _vm.dailyList[index - 1].today && _vm.dailyList[index - 1].completed ? _c('div', {
      staticClass: "rewards-sign__dis"
    }, [_vm._v(" " + _vm._s(_vm._f("formatHour")(_vm.dailyDistance)) + " ")]) : _vm._e()]);
  }), 0)]), _c('div', {
    staticClass: "rewards-imgs"
  }, [_c('div', {
    staticClass: "lucky",
    style: {
      background: `url(${require(`@images/${_vm.aiSkin}/reward-lucky-img.png`)}) center/100% auto no-repeat`
    },
    on: {
      "click": () => _vm.$router.push('/lucky')
    }
  }), _c('div', {
    staticClass: "task",
    style: {
      background: `url(${require(`@images/${_vm.aiSkin}/reward-task-img.png`)}) center/100% auto no-repeat`
    },
    on: {
      "click": () => _vm.$router.push('/task')
    }
  }, [_c('div', {
    staticClass: "task-main"
  }, [_c('div', {
    staticClass: "task__title"
  }, [_vm._v("DO TASKS, GET REWARDS")]), _c('div', {
    staticClass: "task-list"
  }, [_c('div', {
    staticClass: "task-item",
    style: {
      background: `url(${require(`@images/${_vm.aiSkin}/icon/icon-x.png`)}) center/100% auto no-repeat`
    }
  }), _c('div', {
    staticClass: "task-item",
    style: {
      background: `url(${require(`@images/${_vm.aiSkin}/icon/icon-fj.png`)}) center/100% auto no-repeat`
    }
  }), _c('div', {
    staticClass: "task-item",
    style: {
      background: `url(${require(`@images/${_vm.aiSkin}/icon/icon-tp.png`)}) center/100% auto no-repeat`
    }
  }), _c('div', {
    staticClass: "task-item youtube",
    style: {
      background: `url(${require(`@images/${_vm.aiSkin}/icon/icon-youtube.png`)}) center/100% auto no-repeat`
    }
  }), _c('div', {
    staticClass: "task-item",
    style: {
      background: `url(${require(`@images/${_vm.aiSkin}/icon/icon-q.png`)}) center/100% auto no-repeat`
    }
  }), _c('div', {
    staticClass: "task-item",
    style: {
      background: `url(${require(`@images/${_vm.aiSkin}/icon/icon-meta.png`)}) center/100% auto no-repeat`
    }
  })])])])])])]), _c('m-menu')], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };